import {axios} from "@/api/config";
// 查询安全风险信息管理列表
export function listTbWorkPermitReport(params) {
    return axios.get(`/tbWorkPermitReport/list`, params, true);
}

// 查询安全风险信息管理详细
export function getTbWorkPermitReport(reportId) {
    return axios.get(`/tbWorkPermitReport/${reportId}`, reportId, true)
}

// 新增安全风险信息管理
export function addTbWorkPermitReport(params) {
    return axios.post('/tbWorkPermitReport/addTbWorkPermitReport', params, false);
}

// 修改安全风险信息管理
export function updateTbWorkPermitReport(params) {
    return axios.post('/tbWorkPermitReport/editTbWorkPermitReport', params, false);
}


// 删除安全风险信息管理
export function delTbWorkPermitReport(reportId) {
    return axios.delete(`/tbWorkPermitReport/${reportId}`, true)
}